import PropTypes from 'prop-types'
import useStyles from './statistics-callout.styles'

const StatisticsCallout = (props) => {
  const {
    statisticsHeadline,
    statisticsSubtitle,
    statisticsCardsCollection,
  } = props
  const styles = useStyles()

  return (
    <div className={styles.statisticsCallout}>
      <div className={styles.copyContainer}>
        <h3 className={styles.heading}>{statisticsHeadline}</h3>
        <p className={styles.supportiveCopy}>{statisticsSubtitle}</p>
      </div>
      <ul className={styles.calloutList}>
        {statisticsCardsCollection?.items
        && statisticsCardsCollection.items.map((stat, i) => (
          <li className={styles.calloutListItem} key={`statistics-item-${i + 1}`}>
            <h4 className={styles.calloutItem}>
              <div className={styles.calloutShape}>{stat.heading}</div>
              <div className={styles.calloutCopy}>{stat.subtitle}</div>
            </h4>
          </li>
        ))}
      </ul>
    </div>
  )
}

StatisticsCallout.propTypes = {
  statisticsHeadline: PropTypes.string,
  statisticsSubtitle: PropTypes.string,
  statisticsCardsCollection: PropTypes.object,
}

export default StatisticsCallout
